import React, { useEffect, useRef, useState } from 'react';
import { CountUp } from 'use-count-up';

export default function BuzzCountNumber({ count, duration = 2 }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setComplete(true);
      return undefined;
    }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    });
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <span ref={ref}>
      {complete ? (
        count.toLocaleString('en-US')
      ) : visible ? (
        <CountUp
          isCounting
          thousandsSeparator=","
          start={Math.min(650000, count)}
          end={count}
          duration={duration}
          onComplete={() => setComplete(true)}
        />
      ) : (
        Math.min(650000, count).toLocaleString('en-US')
      )}
      +
    </span>
  );
}
